import React, { useMemo, useCallback } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  getAvailableReactionShortNameByType,
  makeIsMyReactionByTypeSelector,
} from "~/store/selectors/selector.reactions.jsx";
import { Reaction } from "./Reaction.jsx";

export const AvailableReactionType = ({ parentType, parentId, type, onClick, ...props }) => {
  const getIsMyReactionByType = useMemo(makeIsMyReactionByTypeSelector, []);
  const reacted = useSelector((state) => getIsMyReactionByType(state, parentType, parentId, type));
  const shortName = useSelector((state) => getAvailableReactionShortNameByType(state, type));

  const handleClick = useCallback(() => {
    !reacted && typeof onClick === "function" && onClick(type);
  }, [onClick, reacted, type]);

  return (
    <Reaction
      shortName={shortName}
      onClick={handleClick}
      reacted={reacted}
      {...props}
    />
  );
};

AvailableReactionType.propTypes = {
  parentType: PropTypes.string,
  parentId: PropTypes.number,
  type: PropTypes.string,
  onClick: PropTypes.func,
};
